import { useState, useEffect, useMemo } from "react";
const rightMapControlsArea = {
  right: 0,
  top: 0,
  width: `48px`,
  height: `100%`
};
const leftMapControlsArea = {
  left: 0,
  top: 0,
  width: `48px`,
  height: `100%`
};
function useOccupiedAreas(element, panelPosition = "left") {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    if (element) {
      const observer = new ResizeObserver(() => {
        setWidth(element == null ? void 0 : element.offsetWidth);
      });
      observer.observe(element);
      return () => observer.unobserve(element);
    }
  }, [element]);
  const occupiedAreas = useMemo(() => {
    if (!element) {
      return;
    }
    const mapControlsArea = panelPosition === "left" ? leftMapControlsArea : rightMapControlsArea;
    return [
      mapControlsArea,
      {
        left: 0,
        top: 0,
        width: `${width}`,
        height: `${100}%`
      }
    ];
  }, [element, panelPosition, width]);
  return occupiedAreas;
}
export {
  useOccupiedAreas
};
